import * as React from 'react';

export const isEmptyCodeBlock = (children: React.ReactNode): boolean => {
  const childArray = React.Children.toArray(children);

  return (
    childArray.length === 1 &&
    React.isValidElement(childArray[0]) &&
    childArray[0].type === 'code' &&
    isEmptyMarkdownBlock((childArray[0] as React.ReactElement<{ children?: React.ReactNode }>).props.children)
  );
};

export const isEmptyMarkdownBlock = (children: React.ReactNode): boolean => {
  const nodes = React.Children.toArray(children);

  if (nodes.length === 0) {
    return true;
  }

  return nodes.every((node) => {
    if (node === null || node === undefined || typeof node === 'boolean') {
      return true;
    }

    if (typeof node === 'string' || typeof node === 'number') {
      return (
        String(node)
          .replace(/\u00a0/g, ' ')
          .trim() === ''
      );
    }

    if (React.isValidElement(node)) {
      return node.type === 'br';
    }

    return true;
  });
};
